export const formatMaterialCount = (count: string) => {
  const value = Number(count);
  if (!value || isNaN(value)) return "";
  return String(value.toFixed(4));
};
